module.exports = __webpack_public_path__ + "img/cake.30768bdf.jpg";